import _defineProperty from "/Users/oluwasetty/projects/Dynamic Portfolio/DynamicPortfolio/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var e = {
  data: ""
},
    t = function t(_t) {
  return "object" == typeof window ? ((_t ? _t.querySelector("#_goober") : window._goober) || Object.assign((_t || document.head).appendChild(document.createElement("style")), {
    innerHTML: " ",
    id: "_goober"
  })).firstChild : _t || e;
},
    r = function r(e) {
  var r = t(e),
      l = r.data;
  return r.data = "", l;
},
    l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
    a = /\/\*[^]*?\*\/|\s\s+|\n/g,
    n = function n(e, t) {
  var r = "",
      l = "",
      a = "";

  var _loop = function _loop(_o2) {
    var s = e[_o2];
    "@" == _o2[0] ? "i" == _o2[1] ? r = _o2 + " " + s + ";" : l += "f" == _o2[1] ? n(s, _o2) : _o2 + "{" + n(s, "k" == _o2[1] ? "" : t) + "}" : "object" == typeof s ? l += n(s, t ? t.replace(/([^,])+/g, function (e) {
      return _o2.replace(/(^:.*)|([^,])+/g, function (t) {
        return /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t;
      });
    }) : _o2) : null != s && (_o2 = _o2.replace(/[A-Z]/g, "-$&").toLowerCase(), a += n.p ? n.p(_o2, s) : _o2 + ":" + s + ";");
    _o = _o2;
  };

  for (var _o in e) {
    _loop(_o);
  }

  return r + (t && a ? t + "{" + a + "}" : a) + l;
},
    o = {},
    s = function s(e) {
  if ("object" == typeof e) {
    var _t2 = "";

    for (var _r in e) {
      _t2 += _r + s(e[_r]);
    }

    return _t2;
  }

  return e;
},
    c = function c(e, t, r, _c, i) {
  var u = s(e),
      p = o[u] || (o[u] = function (e) {
    var t = 0,
        r = 11;

    for (; t < e.length;) {
      r = 101 * r + e.charCodeAt(t++) >>> 0;
    }

    return "go" + r;
  }(u));

  if (!o[p]) {
    var _t3 = u !== e ? e : function (e) {
      var t,
          r = [{}];

      for (; t = l.exec(e.replace(a, ""));) {
        t[4] ? r.shift() : t[3] ? r.unshift(r[0][t[3]] = r[0][t[3]] || {}) : r[0][t[1]] = t[2];
      }

      return r[0];
    }(e);

    o[p] = n(i ? _defineProperty({}, "@keyframes " + p, _t3) : _t3, r ? "" : "." + p);
  }

  return function (e, t, r) {
    -1 == t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
  }(o[p], t, _c), p;
},
    i = function i(e, t, r) {
  return e.reduce(function (e, l, a) {
    var o = t[a];

    if (o && o.call) {
      var _e = o(r),
          _t4 = _e && _e.props && _e.props.className || /^go/.test(_e) && _e;

      o = _t4 ? "." + _t4 : _e && "object" == typeof _e ? _e.props ? "" : n(_e, "") : !1 === _e ? "" : _e;
    }

    return e + l + (null == o ? "" : o);
  }, "");
};

function u(e) {
  var r = this || {},
      l = e.call ? e(r.p) : e;
  return c(l.unshift ? l.raw ? i(l, [].slice.call(arguments, 1), r.p) : l.reduce(function (e, t) {
    return Object.assign(e, t && t.call ? t(r.p) : t);
  }, {}) : l, t(r.target), r.g, r.o, r.k);
}

var p,
    d,
    f,
    g = u.bind({
  g: 1
}),
    b = u.bind({
  k: 1
});

function h(e, t, r, l) {
  n.p = t, p = e, d = r, f = l;
}

function m(e, t) {
  var r = this || {};
  return function () {
    var l = arguments;

    function a(n, o) {
      var s = Object.assign({}, n),
          c = s.className || a.className;
      r.p = Object.assign({
        theme: d && d()
      }, s), r.o = / *go\d+/.test(c), s.className = u.apply(r, l) + (c ? " " + c : ""), t && (s.ref = o);
      var i = e;
      return e[0] && (i = s.as || e, delete s.as), f && i[0] && f(s), p(i, s);
    }

    return t ? t(a) : a;
  };
}

export { u as css, r as extractCss, g as glob, b as keyframes, h as setup, m as styled };